export const MultiviewEvent = {
    SelectAll: "multiview:selectAll",
    SelectAllOnPage: "multiview:selectAllOnPage"
} as const;

export const MultiviewMode = {
    Grid: "grid",
    List: "list"
} as const;

export type MultiviewModeType = (typeof MultiviewMode)[keyof typeof MultiviewMode];

export default {
    MultiviewEvent,
    MultiviewMode
} as const;
